module.exports = __webpack_public_path__ + "img/shoplogo.e6848a40.svg";